<div>
    <p class="tw-mb-0" [innerHTML]="'adminPerformanceProfiles.profileLimitDialog.description' | transloco"></p>
    <div class="tw-flex tw-justify-end tw-mt-6">
        <p-button
            [label]="'adminPerformanceProfile.profileLimitDialog.cancelBtnLabel' | transloco"
            severity="secondary"
            variant="text"
            class="tw-mr-4"
            data-test="admin-performance-proile-max-limit-cancel-button"
            (onClick)="cancel()"
        />
        <p-button
            [label]="'adminPerformanceProfile.profileLimitDialog.requestQuoteBtnLabel' | transloco"
            severity="primary"
            data-test="admin-performance-proile-max-limit-request-button"
            (onClick)="confirm()"
        />
    </div>
</div>
